import type { ReactNode } from 'react';
import { Button, ButtonGroup } from '@chakra-ui/react';
import { DialogBox, type DialogBoxProps } from './DialogBox';

interface ConfirmationDialogProps extends Omit<DialogBoxProps, 'header' | 'body' | 'footer'> {
  title: ReactNode;
  body: ReactNode;
  onConfirm: () => void;
  confirmLabel: ReactNode;
  cancelLabel?: ReactNode;
  isLoading?: boolean;
  variant?: 'destructive' | 'default';
}

export function ConfirmationDialog({
  title,
  body,
  onConfirm,
  onClose,
  confirmLabel,
  cancelLabel,
  isLoading,
  variant = 'default',
  ...dialogProps
}: ConfirmationDialogProps) {
  const confirmButtonProps =
    variant === 'destructive' ? { colorScheme: 'red' as const, bg: 'danger' } : {};

  return (
    <DialogBox
      onClose={onClose}
      header={title}
      body={body}
      footer={
        <ButtonGroup>
          <Button variant="secondary" onClick={onClose}>
            {cancelLabel ?? 'Cancel'}
          </Button>
          <Button onClick={onConfirm} isLoading={isLoading} {...confirmButtonProps}>
            {confirmLabel}
          </Button>
        </ButtonGroup>
      }
      {...dialogProps}
    />
  );
}
